import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    drawerContainer: 'rounded-none',
    drawerContent:
      'flex flex-col overflow-hidden! rounded-none px-4 pt-6 pb-0 sm:w-121.25 sm:overflow-hidden! sm:rounded-none sm:py-15 sm:pr-0 sm:pl-15',
    closeButton: 'flex sm:flex',
    divider:
      'bg-disabled relative top-0 left-1/2 mb-4 h-1.5 w-13 -translate-x-1/2 rounded-full sm:hidden'
  }
});
